import { render, staticRenderFns } from "./fixed-header.vue?vue&type=template&id=3a5af1c0&scoped=true&"
import script from "./fixed-header.vue?vue&type=script&lang=js&"
export * from "./fixed-header.vue?vue&type=script&lang=js&"
import style0 from "./fixed-header.vue?vue&type=style&index=0&id=3a5af1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5af1c0",
  null
  
)

export default component.exports